
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 43 31","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.544 10.52c.26-.002.442.047.658.242l5.392 4.856c.383.34.454 1.006.077 1.38-.365.362-1.014.406-1.394.062l-3.753-3.384v10.44a.975.975 0 01-.98.97.976.976 0 01-.98-.97v-10.44L16.81 17.06c-.381.344-1.048.317-1.394-.062-.346-.378-.326-1.033.076-1.38l5.392-4.856a1.07 1.07 0 01.659-.243m0-10.197c-3.137 0-6.277 1.18-8.67 3.55a12.048 12.048 0 00-3.508 7.178c-4.993.45-8.9 4.603-8.9 9.667 0 5.363 4.39 9.71 9.804 9.71h24.018c4.616 0 8.332-3.68 8.332-8.254 0-4.573-3.716-8.255-8.332-8.255h-.583a12.073 12.073 0 00-3.507-10.045A12.246 12.246 0 0021.544.322","fill":"#000","fill-rule":"evenodd"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/management/drop.svg